<template>
  <div id="noLogin">
    <div class="header">
      <img v-bind:src="imgUrl" alt class="bg" />
      <div class="top dl_center">
        <ul class="title dl_margin2_top">
          <li
            v-for="(item, index) in list"
            @click="toggle(index)"
            :class="{ is_active: index == active }"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
        <a :href="kefuurl"
          ><img
            src="../assets/img/login_ico_kefu.png"
            alt
            class="cata dl_margin3_top wx_rt"
        /></a>
      </div>
    </div>
    <div class="content" style="display: block">
      <div class="main1">
        <p class="wx_fontSize4 title_wallet">
          {{ $t("nologin.cloud_wallet") }}
        </p>
        <div class="top_main">
          <img src="../assets/img/login_ico_anquan_yunduan.png" alt />
          <span class="wx_fontSize2">{{ $t("nologin.cloud1") }}</span>
        </div>
        <div class="top_main">
          <img src="../assets/img/login_ico_zichan_yunduan.png" alt />
          <span class="wx_fontSize2">{{ $t("nologin.cloud2") }}</span>
        </div>
        <div class="top_main">
          <img src="../assets/img/login_ico_daibi_yunduan.png" alt />
          <span class="wx_fontSize2">{{ $t("nologin.cloud3") }}</span>
        </div>
      </div>
      <div class="button">
        <div class="resgiter wx_lf" @click="register()">
          <div class="zhuce-btn bg-blue">{{ $t("nologin.button1") }}</div>
        </div>
        <!-- <div class="login wx_rt" @click="login()">
          <div class="zhuce-btn bg-blue">{{ $t("nologin.button2") }}</div>
        </div> -->
        <div class="login login-2u wx_rt" @click="loginWithUU()">
          <div class="zhuce-btn">{{ $t("nologin.button_oauth") }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="main1">
        <p class="wx_fontSize4 title_wallet">{{ $t("nologin.hd_wallet") }}</p>
        <div class="top_main">
          <img src="../assets/img/login_ico_siyao_bendi.png" alt />
          <span class="wx_fontSize2">{{ $t("nologin.hd1") }}</span>
        </div>
        <div class="top_main">
          <img src="../assets/img/login_ico_daoru_bendi.png" alt />
          <span class="wx_fontSize2">{{ $t("nologin.hd2") }}</span>
        </div>
        <div class="top_main">
          <img src="../assets/img/login_ico_daibi_bendi.png" alt />
          <span class="wx_fontSize2">{{ $t("nologin.hd3") }}</span>
        </div>
      </div>
      <div class="button">
        <div class="resgiter wx_lf" @click="register()">
          <div class="zhuce-btn bg-blue2">{{ $t("nologin.button3") }}</div>
        </div>
        <!-- <div class="login wx_rt" :title="$t('nologin:cloud1')" @click="login()">
          <div class="zhuce-btn bg-blue2">{{ $t("nologin.button4") }}</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { validateEmpty } from "@/utils/validate";
import { Toast } from "mint-ui";
import { httpDoOauth } from "@/api/login";
import { loginIn } from "@/utils/index";

export default {
  data: function () {
    return {
      kefuurl: this.$store.state.initInfo.system_customer_service,
      list: [this.$t("nologin.cloud_wallet"), this.$t("nologin.hd_wallet")],
      active: 0,
      imgUrl: require("../assets/img/login_bg_yunduan.png"),
    };
  },
  activated() {
    this.token = this.$store.getters.token;
    if (!validateEmpty(this.token)) {
      this.$router.replace("/index/home");
    }

    const params = new URLSearchParams(location.search);
    if (params.has("token")) {
      //oauth回调已直接签发登录token，直接自动登录
      this.doTokenLogin(params.get("token"));
      return;
    }
    if (params.has("access_token")) {
      this.token = params.get("access_token");
      this.doOauth();
    }
  },
  methods: {
    toggle(index) {
      this.active = index;
      var tabCardCollection = document.querySelectorAll(".content"),
        len = tabCardCollection.length;
      for (var i = 0; i < len; i++) {
        tabCardCollection[i].style.display = "none";
      }
      tabCardCollection[index].style.display = "block";
      if (index == 0) {
        document.querySelector(".cata").style.display = "block";
        this.isShow = false;
        this.imgUrl = require("../assets/img/login_bg_yunduan.png");
      } else if (index == 1) {
        document.querySelector(".cata").style.display = "none";
        this.show = false;
        this.imgUrl = require("../assets/img/login_bg_bendi.png");
      }
    },
    register() {
      this.$router.push("/register");
    },
    login() {
      this.$router.push("/");
    },
    loginWithUU() {
      var service_name = "auwallet"; //should be changed to auwallet after wallet backend's update
      // var service_name = "testauwallet"; //should be changed to auwallet after wallet backend's update
      var device_name = "web";
      window.location.href =
        "https://oauth.auwallet.io/login?service=" +
        service_name +
        "&device=" +
        device_name +
        "&redirecturi=" +
        window.location.href;
    },

    removeParam(key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },

    doTokenLogin(token) {
      this.$store.dispatch("setToken", token);
      loginIn(token);
      var url = window.location.href;
      url = this.removeParam("token", url);
      url = this.removeParam("access_token", url);
      url = this.removeParam("accid", url);
      url = this.removeParam("email", url);
      url = this.removeParam("mobile", url);
      window.location.href = url;
    },

    doOauth() {
      var data = {
        access_token: this.token,
      };

      httpDoOauth(data)
        .then((res) => {
          //Toast(res.msg);
          if (res.data.success == "true") {
            this.res = res;
            this.$store.dispatch("setToken", res.data.token);
            this.$store.dispatch("setUserInfo", res.data.user);
            var url = window.location.href;
            url = this.removeParam("access_token",url);
            window.location.href = url;
            //this.$router.replace("/index/home");
            console.log(JSON.stringify(res.data.user));
          }

          loginIn(res.data.token);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
#noLogin {
  position: relative;
  width: 100%;
  background: #f6f6f6;
  height: 100%;
  z-index: 1000;
}
/*顶部*/
.header {
  width: 100%;
  height: 200px;
}
.header .bg {
  width: 100%;
  height: 100%;
}
.top {
  width: 100%;
  height: 48px;
  position: absolute;
  top: 0;
}
.file {
  width: 20px;
  height: 20px;
  margin-left: 15px;
}
.cata {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}
.title {
  width: calc(100% - 114px);
  height: 28px;
  border: 1px solid #fff;
  border-radius: 5px;
  position: absolute;
  left: 57px;
}
.title li {
  width: 50%;
  height: 100%;
  float: left;
  color: #fff;
  font-size: 0.875rem;
  text-align: center;
  line-height: 28px;
}
.title .is_active {
  background: #fff;
  color: #0191f5;
}
/*内容*/
.content {
  background: #f6f6f6;
  width: 80%;
  display: none;
  padding: 0 10%;
  z-index: 1000;
}
.main1 {
  width: 100%;
  margin-top: 25px;
  box-shadow: 0 0 20px rgba(0, 119, 255, 0.2);
  background: #fff;
  padding-bottom: 20px;
  padding: 10px;
  box-sizing: border-box;
}
.button {
  width: 100%;
  position: relative;
  height: 56px;
  margin-top: 25px;
}
.resgiter,
.login {
  width: 47%;
}
.resgiter {
  margin-right: 2%;
}
.login {
  margin-left: 2%;
}
.login-2u {
  margin-top: 6%;
  background-color: #35c758;
  width: 100% !important;
}
.resgiter img,
.login img {
  width: 100%;
  height: 56px;
}
.title_wallet {
  width: 100%;
  text-align: center;
  color: #212529;
}
.top_main {
  padding: 10px;
}
.top_main img {
  width: 20px;
  height: 20px;
}
.top_main span {
  color: #8c92a8;
  position: relative;
  top: -5px;
  margin-left: 10px;
}
.zhuce-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
}
.bg-blue {
  background-color: #1980d6;
}
.bg-blue2 {
  background-color: #5351f1;
}
</style>